<template>
  <v-container style="max-width: 800px;">
    <v-btn text class="mb-4" @click="$router.back()">
      <v-icon left>mdi-arrow-left</v-icon>
      戻る
    </v-btn>
    <h1 class="text-h5 font-weight-bold mb-6">著作権・免責事項</h1>
    <div class="body-1">

      <h2 class="text-h6 font-weight-bold mt-4 mb-3">著作権について</h2>
      <p>
        本サイトに含まれるすべてのコンテンツ（文章、画像、プログラムなど）の著作権は、当サイト運営者に帰属します。権利者の許可なく複製、転載、配布することは禁止されています。著作権侵害となり、法的に罰せられるほか、損害賠償を請求されることがあります。
      </p>

      <h2 class="text-h6 font-weight-bold mt-6 mb-3">免責事項について</h2>
      <p>
        当サイトの情報はできる限り正確なものを提供するよう努めていますが、その正確性、完全性、最新性を保証するものではありません。
      </p>
      <p>
        利用者が当サイトに基づいて被ったとされるいかなる損害についても、当サイトおよびその情報提供者は責任を負いません。サービスの利用は利用者自身の判断と責任において行ってください。
      </p>
      <p>
        当サイトは、予告なしにサービスの内容を変更・停止する場合があります。これにより利用者に損害が生じた場合でも、当サイトは一切の責任を負いません。
      </p>

      <h2 class="text-h6 font-weight-bold mt-6 mb-3">リンクについて</h2>
      <p>
        当サイトからリンクされている外部サイトの内容については、当サイトは責任を負いません。外部サイトの利用については、各サイトの利用規約に従ってください。
      </p>

      <p class="mt-8 grey--text">制定日：2023年11月</p>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Terms',
}
</script>
